// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y7XC","largestCol":"styles_largestCol__13PBI","smallestCol":"styles_smallestCol__BwO8z"};